<template>
  <div
    id="hekate-loader"
    class="hekate-loader d-none"
  >
    <div class="formfort-loading"></div>
  </div>
</template>
